import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';
import { base64 } from '@firebase/util';
import { HotelAPI, AuthService, HotelConfig } from "@easyfo/common-lib";

@Injectable({
  providedIn: 'root',
})
export class HotelService {
  constructor(
    private hotelAPI: HotelAPI,
    private cookieService: CookieService,
    private authService: AuthService
  ) { }

  requestCheckHotelLicense(hotelId: string, callback: any) {
    var maxDay = environment.license.max_day_warn;
    var license: HotelConfig.LicenseInformation = {
      expired: true,
      expiredSoon: true,
      days: 0,
    };

    let jwt = base64.decodeString(this.cookieService.get('authorized'), false);
    this.hotelAPI.requestCheckHotelLicense(jwt, hotelId).subscribe({
      next: (response: HotelConfig.LicenseResponseDTO) => {
        if (response.success == true) {
          var licenseDate = new Date(response.expired);
          var currentDate = new Date();
          var Difference_In_Time =
            (licenseDate.getTime() - currentDate.getTime()) /
            (1000 * 3600 * 24);

          if (Difference_In_Time > maxDay) {
            license.expired = false;
            license.expiredSoon = false;
          } else {
            license.expired = false;
            license.expiredSoon = true;
            license.days = Math.floor(Difference_In_Time);
          }
        }
        callback(license);
      },
      error: (error) => {
        if (this.authService.handleSessionExpired(error) == true) {
          return;
        } else {
          callback(license);
        }
      }
    });
  }

  getHotelBackground(hotelId: string, callback: any) {
    this.getHotelImage(hotelId, "1", (res: any) => {
      localStorage.setItem("bimg", res);
      callback();
    });
  }

  getHotelImage(hotelId: string, imageId: string, callback: any) {
    let jwt = base64.decodeString(this.cookieService.get('authorized'), false);
    this.hotelAPI.requestHotelImage(jwt, hotelId, imageId)
      .subscribe((response: any) => {
        callback(response)
      }, (error: any) => {
        callback();
      });
  }

}
